module.exports = __webpack_public_path__ + "static/media/binDeleteIcon.6356e4eb.svg";